var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2569 20.074C9.87935 25.5054 5.32416 32.1255 7.59687 33.7493C7.83923 33.9186 8.10649 34 8.40031 34C10.5982 34 14.1208 29.4749 17.2017 24.757C16.0763 23.0654 15.0553 21.4121 14.2519 20.0692L14.2569 20.074Z",
    fill: "url(#paint0_linear_712_987)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3133 13.0323C19.7572 13.6399 18.801 14.699 17.6406 16.032C18.469 16.8686 19.5098 17.9526 20.637 19.1727C21.716 17.3234 22.5576 15.7896 23.0124 14.953C23.2249 15.0127 23.4457 15.0542 23.6665 15.0808C25.8644 15.3746 28.3874 14.1927 30.3648 11.4171C33.0424 7.66051 33.7047 2.40829 31.1848 0.613668C28.6682 -1.17917 23.9222 1.16646 21.2496 4.92621C19.2742 7.70509 18.9804 10.4758 19.9797 12.4562C20.0809 12.6554 20.1872 12.8479 20.315 13.0305L20.3133 13.0323Z",
    fill: "url(#paint1_linear_712_987)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75127 13.7811C5.01521 14.1248 5.28744 14.4435 5.56303 14.7423C7.88708 17.2622 10.377 17.8614 12.5618 17.1526C12.766 17.0846 12.9652 17.0082 13.1611 16.9186C14.1986 18.7761 22.7228 33.7858 26.9125 33.7858C27.2528 33.7858 27.5632 33.6879 27.8388 33.4754C31.5323 30.6501 17.3158 16.5831 15.6839 14.9844C15.8201 14.8184 15.9479 14.6441 16.0657 14.4664C17.324 12.5408 17.3921 9.97922 15.5677 7.08096C15.3503 6.73734 15.1129 6.38874 14.8489 6.04843L10.6043 0.502218C10.1793 -0.0538902 9.38084 -0.160132 8.81976 0.264837C8.26365 0.689801 8.15741 1.48827 8.58238 2.04935L12.0552 6.58797C12.4801 7.14408 12.3789 7.9442 11.8178 8.37248C11.2617 8.79744 10.4615 8.69618 10.0333 8.1351L6.56049 3.59648C6.13553 3.04037 5.33706 2.93413 4.77598 3.3591C4.21987 3.78406 4.11363 4.58253 4.5386 5.14361L8.01137 9.68223C8.43633 10.2383 8.33507 11.0385 7.77399 11.4667C7.21788 11.8917 6.41776 11.7904 5.98948 11.2294L2.51671 6.69074C2.09174 6.13463 1.29328 6.02839 0.732198 6.45335C0.17609 6.88329 0.0698489 7.67678 0.494818 8.23787L4.73949 13.7841L4.75127 13.7811Z",
    fill: "url(#paint2_linear_712_987)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_712_987",
    x1: 12.097,
    y1: 20.0692,
    x2: 12.097,
    y2: 44.0127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_712_987",
    x1: 25.2019,
    y1: 0,
    x2: 25.2019,
    y2: 32.9531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_712_987",
    x1: 14.3416,
    y1: 0.00439453,
    x2: 14.3416,
    y2: 58.0663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.7324ba29a8e43af52c3d20809f0e85ce.svg";
export { ForwardRef as ReactComponent };